import { inject, Injectable } from '@angular/core';
import { StateContext } from '@ngxs/store';
import { TableStateModel } from '../table.state.model';
import { Pagination } from '@core/models/pagination.model';
import { TableActions } from '../table.actions';
import { FacialRecognitionLogService } from '@core/services/facial-recognition-log.service';

@Injectable({
  providedIn: 'root',
})
export class FacialRecognitionLogHandler {
  constructor() {}
  facialRecognitionLogService = inject(FacialRecognitionLogService);

  handleFacialRecognitionLogsLoad(
    ctx: StateContext<TableStateModel>,
    params: Pagination
  ) {
    this.facialRecognitionLogService.getFacialRecognitionLogs({ ...params }).subscribe({
      next: (response) => {
        ctx.dispatch(
          new TableActions.LoadTableDataSuccess({
            tableKey: 'facialRecognitionLog',
            data: response.data?.data,
            totalCount: response.data?.total_count,
          })
        );
      },
      error: (error) => {
        ctx.dispatch(
          new TableActions.LoadTableDataFailure({
            tableKey: 'facialRecognitionLog',
            error: error.message,
          })
        );
      },
    });
  }

  filterFacialRecognitionLogList(
    ctx: StateContext<TableStateModel>,
    action: TableActions.FilterFacialRecognitionLogList
  ) {
    return this.facialRecognitionLogService
      .getFacialRecognitionLogs(undefined, action.payload.filter)
      .subscribe({
        next: (response) => {
          ctx.dispatch(
            new TableActions.LoadTableDataSuccess({
              tableKey: 'facialRecognitionLog',
              data: response.data?.data,
              totalCount: response.data?.total_count,
            })
          );
        },
        error: (error) => {
          ctx.dispatch(
            new TableActions.LoadTableDataFailure({
              tableKey: 'facialRecognitionLog',
              error: error.message,
            })
          );
        },
      });
  }
}
